module.exports = __webpack_public_path__ + "static/media/Jaswita.e80ebc09.jpg";